import { ESSElement, SquareElement } from './element'

class WebSocketServer {
  static #instance
  static Instance(topology, url) {
    if (!this.#instance) {
      this.#instance = new this(topology, url)
    }
    return this.#instance
  }

  /**
   * @constructor websocket服务
   * @param {import('./topology').Topology} topology 拓扑图对象
   * @param {string|string[]} url websocket地址
   */
  constructor(topology, url) {
    this.topology = topology
    this.url = url
    this.urlIndex = 0
    this.connectCount = 0
    this.websocket = null

    // status
    this.monitorRunning = false
    this.timer = null
    this.interval = 2000

    // 连接
    this.connect()
  }

  connect() {
    if (this.connectCount >= 5) {
      return
    }
    // 连接
    this.websocket = new WebSocket(this.#getUrl())
    this.#addMessageListener()
    this.#addCloseListener()
    this.connectCount++
  }


  #addMessageListener() {
    this.websocket.addEventListener('message', (event) => {
      try {
        let res = JSON.parse(event.data)

        // 忽略告警信息（告警信息带有isActive）
        if (res.isActive) {
          return
        }

        // 触发数据更新事件
        ////////////////////////////
        this.topology.dispatchEvent({
          type: 'topo:dataChange',
          data: res.data
        })

        const obj = {} //{uuid: {}}
        Object.keys(res.data).forEach(dataKey => {
          const dataMap = res.data[dataKey]
          Object.keys(dataMap).forEach(key => {
            obj[key] = dataMap[key]
          })
        })


        ///////////////////////
        this.#updateData(obj)

      } catch (error) {
        console.warn(error)
      }
    })
  }

  #addCloseListener() {
    this.websocket.addEventListener('close', () => {
      console.warn('[ws] close')
      console.warn(`[ws] try connect ${this.connectCount} times`)
      if (Array.isArray(this.url)) {
        this.urlIndex++
        // 连接
        this.connect()
      }
    })
  }


  startMonitor() {
    if (this.monitorRunning) {
      // eui.showToast('monitor is running', 'warning')
      return
    }

    const data = {
      method: 'ws_device_diagram',
      params: {},
      timestamp: Date.now(),
    }


    this.timer = setInterval(() => {
      this.websocket.send(JSON.stringify(data))
    }, this.interval)

    // eui.showToast('monitor start', 'info')
    this.monitorRunning = true

  }

  stopMonitor() {
    clearInterval(this.timer)
  }

  /**
   * 更新数据
   * @param {object} dataObject dataObject 是数据集合 如 {uuid: {i_a: 0. u_ab: 0}, uuid2: {i_a: 0. u_ab: 0}}
   */
  #updateData(dataObject) {

    for (const elem of this.topology.storage.displayElement) {
      let uuid = elem.deviceUUID
      if (elem instanceof ESSElement || elem instanceof SquareElement) {
        const [_, devUuid] = elem.deviceUUID.split('-')
        uuid = devUuid
      }
      const valueObject = dataObject[uuid] || {}
      if (typeof elem.updateData === 'function') {
        elem.updateData(valueObject, dataObject)
      }
    }
  }
  #getUrl() {
    return Array.isArray(this.url) ? this.url[this.urlIndex % this.url.length] : this.url
  }

}

export { WebSocketServer }
